<template>
  <button
    type="button"
    class="app-btn"
    :class="classes"
    :style="widthStyle"
    :disabled="disabled || loading"
    :aria-pressed="pressed ? 'true' : null"
    :aria-busy="loading ? 'true' : null"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span v-if="loading" class="app-spinner app-btn__icon" aria-hidden="true"></span>
    <app-icon v-else-if="icon" :name="icon" :size="16" class="app-btn__icon" />
    <span class="app-btn__label"><slot /></span>
    <span v-if="title" class="app-sr-only">, {{ title }}</span>
    <app-icon v-if="chevron" name="chevD" :size="14" class="app-btn__chev" />
    <v-tooltip
      v-if="tooltipOn"
      :activator="$el"
      bottom
      open-delay="400"
      content-class="app-tooltip"
    >
      <span>{{ title }}</span>
    </v-tooltip>
  </button>
</template>

<script>
// Beschrifteter Knopf (Spezifikation 2.6). Stufen: secondary (Standard), primary (genau eine Hauptaktion je
// Seite/Bereich), danger, field (Filter-/Auswahlknopf im Feldstil), tertiary (randlos, nur Menüs/Navigation).
// Wurzel ist das <button>; $attrs und $listeners gehen direkt darauf, dadurch taugt er als v-menu-Aktivator:
//   <template v-slot:activator="{ on, attrs }"><app-button v-bind="attrs" v-on="on">…</app-button></template>
// title: Tooltip (nur Maus) und Ergänzung des zugänglichen Namens. Der Tooltip hängt über die activator-Prop am
// Knopf selbst, damit $el der Knopf bleibt (ein v-tooltip als Wurzel wäre ein unsichtbares span).
import AppIcon from './AppIcon.vue';

const KINDS = ['secondary', 'primary', 'danger', 'field', 'tertiary'];

export default {
  name: 'AppButton',
  components: { AppIcon },
  inheritAttrs: false,
  props: {
    kind: { type: String, default: 'secondary' },
    icon: { type: String, default: null },
    chevron: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    title: { type: String, default: null },
    block: { type: Boolean, default: false },
    width: { type: [Number, String], default: null },
    pressed: { type: Boolean, default: false }
  },
  data() {
    return { mounted: false };
  },
  computed: {
    kindName() {
      return KINDS.indexOf(this.kind) !== -1 ? this.kind : 'secondary';
    },
    classes() {
      return [
        'app-btn--' + this.kindName,
        {
          'app-btn--with-icon': !!this.icon || this.loading,
          'app-btn--with-chevron': this.chevron,
          'app-btn--block': this.block,
          'app-btn--fixed': this.width !== null && this.width !== '',
          'app-btn--pressed': this.pressed,
          'app-btn--loading': this.loading
        }
      ];
    },
    widthStyle() {
      if (this.width === null || this.width === '') {
        return null;
      }
      const w = String(this.width);
      return { width: /^\d+(\.\d+)?$/.test(w) ? w + 'px' : w };
    },
    tooltipOn() {
      const touch = !!(this.$dichte && this.$dichte.touch);
      return this.mounted && !!this.title && !touch && this.$attrs['aria-expanded'] !== 'true';
    }
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    focus() {
      this.$el.focus();
    }
  }
};
</script>
